import { LanguagesMenu, LanguagesMenuMobile, LanguagesMenuPC } from "./loader";

export const preload = isPC => {
  if (isPC) LanguagesMenuPC.preload();
  else LanguagesMenuMobile.preload();
  LanguagesMenu.preload();
};
